import { GameLang } from "@lib/js-slingo-pawnshop-core/dist/game/view/abstract/lang/GameLang";
import { AbstractSlingoAnimationSpineProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractSlingoAnimationProperties";
import { FontStyle } from "@lib/titan2-slingo/dist/game/view/abstract/style/FontStyle";
import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import * as PIXI from "pixi.js";
/**
 * SlingoAnimationLandscapeProperties.ts
 */
export class SlingoAnimationLandscapeProperties extends AbstractSlingoAnimationSpineProperties {
    setDefaultValues() {
        super.setDefaultValues();
        this.hasMultiple = false;
        this.animationProperties.position = new PIXI.Point(1373, 640);
        let textPosition = new PIXI.Point(1340, 360);
        let textSize = new PIXI.Point(700, 180);
        let slingo2 = new TextFieldProperties(FontStyle.SLINGO_2_ANIMATION, textPosition, GameLang.DOUBLE, ControlConstants.CENTER);
        let slingo3 = new TextFieldProperties(FontStyle.SLINGO_3_ANIMATION, textPosition, GameLang.TRIPLE, ControlConstants.CENTER);
        let slingo4 = new TextFieldProperties(FontStyle.SLINGO_4_ANIMATION, textPosition, GameLang.QUADRUPLE, ControlConstants.CENTER);
        slingo2.size = textSize;
        slingo3.size = textSize;
        slingo4.size = textSize;
        this.amountFields.setValue(2, slingo2);
        this.amountFields.setValue(3, slingo3);
        this.amountFields.setValue(4, slingo4);
        this.animationNameArray = [null, "slingo", "slingo_double", "slingo_triple", "slingo_quadruple"];
    }
}
